import React from 'react'

import { AppFC } from 'types'
import useNavigateTo from 'hooks/useNavigateTo'

import { IRecommendationCardProps } from 'components/Common/RecommendationCard'
import DraggableContentArea from 'components/Common/DraggableContentArea'
import SectionTitle from 'components/Common/SectionTitle'
import PlaysDefinitionTooltip from 'components/Common/PlaysDefinitionTooltip'
import Loader from 'components/Loaders'
import { CURRENT_TAB } from 'config/enums'
import { RecommendationCardContainer } from 'pages/Assessment/containers'

export interface INextPlaysProps {
  recommendations: IRecommendationCardProps[]
  isLoadingRecommendations: Boolean
}

/** Despite the section being referred to as "Next Plays", the displayed cards refer to a mix of plays and assessments */
const NextPlays: AppFC<INextPlaysProps> = ({
  recommendations = [],
  className = '',
  isLoadingRecommendations,
}) => {
  const navigate = useNavigateTo('playBooks')
  return (
    <section
      id="owner-next-plays-section"
      className={`flex flex-col items-start gap-3 lg:overflow-hidden ${className}`}
    >
      <div className="flex justify-between items-center gap-4 min-w-[300px]">
        <div className="flex items-center gap-2.5">
          <SectionTitle>Next Plays</SectionTitle>
          <div className="h-7 w-7 flex items-center justify-center mt-0.5">
            <PlaysDefinitionTooltip />
          </div>
        </div>
        <p
          onClick={navigate}
          className="text-primary hover:text-primary-brand hover:cursor-pointer text-base font-semibold whitespace-nowrap"
        >
          See All
        </p>
      </div>
      {isLoadingRecommendations ? (
        <Loader loader={'PlaysRecommendationLoader'}></Loader>
      ) : (
        <div className="overflow-hidden max-w-full min-w-full">
          <DraggableContentArea>
            {recommendations.map((recommendation, idx) => {
              return (
                <RecommendationCardContainer
                  viewedCardFrom={CURRENT_TAB.DASHBOARD}
                  id={recommendation.id}
                  title={recommendation.title}
                  category={recommendation.category}
                  key={`recommendation-card-${idx + 1}`}
                  businessTopic={recommendation.businessTopic}
                  level={recommendation.level}
                />
              )
            })}
          </DraggableContentArea>
        </div>
      )}
    </section>
  )
}

export default NextPlays
